import { AttachmentFileType, CloudFile, UriFile } from 'owa-attachment-file-types';
import { AttachmentState } from 'owa-attachment-full-data';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';

export default {
    AttachmentCreation: {
        datapoint: {
            name: 'AttachmentCreation',
            customData: (
                isInline: boolean,
                shouldShare: boolean,
                attachmentFileType: AttachmentFileType,
                size: number
            ) => [isInline, shouldShare, attachmentFileType, size],
        },
    },
    AttachmentDeletion: {
        datapoint: {
            name: 'AttachmentDeletion',
            customData: (isInline: boolean, isCloudy: boolean, size: number) => [isCloudy, size],
        },
    },
    AttachmentCreationFailure: {
        datapoint: {
            name: 'AttachmentCreationFailure',
            customData: (error: string) => [null],
        },
    },
    AttachmentDeletionFailure: {
        datapoint: {
            name: 'AttachmentDeletionFailure',
            customData: (error: string) => [error],
        },
    },
    AttachmentCreationClassicFromAttachmentDataProvider: {
        datapoint: {
            name: 'AttachmentCreationClassicFromAttachmentDataProvider',
            customData: (providerType: AttachmentDataProviderType) => [providerType],
        },
    },
    AttachmentCreationClassicFromLocalFile: {
        datapoint: {
            name: 'AttachmentCreationClassicFromLocalFile',
            customData: (parentItemId, attachment, cancellationId, backingObject: Blob) => {
                return backingObject ? [backingObject.size] : [0]; // Log 0 if no backing object
            },
        },
    },
    AttachmentCreationFromRecentAttachment: {
        datapoint: {
            name: 'AttachmentCreationFromRecentAttachment',
            customData: (parentItemId, attachment, cancellationId, backingObject: Blob) => {
                return backingObject ? [backingObject.size] : [0]; // Log 0 if no backing object
            },
        },
    },
    AttachmentCreationClassicFromLocalFileSliced: {
        datapoint: {
            name: 'AttachmentCreationClassicFromLocalFileSliced',
            customData: (size: number) => [size],
        },
    },
    AttachmentCreationCloudyFromAttachmentDataProvider: {
        datapoint: {
            name: 'AttachmentCreationCloudyFromAttachmentDataProvider',
            customData: (
                parentItemId,
                cancellationId,
                backingObject: CloudFile,
                attachmentState
            ) => [backingObject.providerType],
        },
    },
    AttachmentCreationCloudyFromLocalFile: {
        datapoint: {
            name: 'AttachmentCreationCloudyFromLocalFile',
        },
    },
    UploadLocalFileAndCreateCloudyAttachment: {
        datapoint: {
            name: 'UploadLocalFileAndCreateCloudyAttachment',
        },
    },
    AttachmentSaveAllToCloud: {
        datapoint: {
            name: 'AttachmentSaveAllToCloud',
            customData: (
                attachmentsTotalSize: number,
                succeeded: boolean,
                lastResult: AttachmentResultCode
            ) => [attachmentsTotalSize, succeeded, lastResult],
        },
    },
    AttachmentDeletionAction: {
        datapoint: {
            name: 'AttachmentDeletionAction',
            customData: (
                attachmentWellViewState: AttachmentWellViewState,
                attachmentState: AttachmentState
            ): any => {
                return {
                    generatedAttachmentId: attachmentState.attachmentId.Id,
                };
            },
        },
    },
    AttachmentWellInitialization: {
        datapoint: { name: 'AttachmentWellInitialization', isVerbose: true },
    },
    AttachmentsCanNotShareInternally: { datapoint: { name: 'AttachmentsCanNotShareInternally' } },
    AttachmentCreationFromUri: {
        datapoint: {
            name: 'AttachmentCreationFromUri',
            customData: (backingObject: UriFile): any => {
                return { size: backingObject ? backingObject.size : 0 };
            },
        },
    },
    AttachmentIncludeMostRecentAttachments: {
        datapoint: { name: 'AttachmentIncludeMostRecentAttachments' },
    },
    AttachmentDoNotIncludeMostRecentAttachments: {
        datapoint: { name: 'AttachmentDoNotIncludeMostRecentAttachments' },
    },
    AttachmentShowIncludeMostRecentAttachmentsMessage: {
        datapoint: { name: 'AttachmentShowIncludeMostRecentAttachmentsMessage' },
    },
    SharingTipsConvertToClassic: { datapoint: { name: 'SharingTipsConvertToClassic' } },
    AttachmentSharingTipsAdded: {
        datapoint: {
            name: 'AttachmentSharingTipAdded',
            customData: (sharingTipIds: string[]) => sharingTipIds,
        },
    },
    AttachmentSharingTipsRemoved: {
        datapoint: {
            name: 'AttachmentSharingTipsRemoved',
            customData: (sharingTipIds: string[]) => sharingTipIds,
        },
    },
    AttachmentComposeSPLinkRemove: { datapoint: { name: 'AttachmentComposeSPLinkRemove' } },
    AttachmentRefreshSharingTips: { datapoint: { name: 'AttachmentRefreshSharingTips' } },
};
